export enum EXECUTION_TEMPLATE {
  DEALER_ADVERTISING = "ExecutionBriefDealerAdvertising",
  EDM = "ExecutionBriefEdm",
  INSTORE_DIGITAL = "ExecutionBriefVisMerchDigital",
  INSTORE_PRINT = "ExecutionBriefVisMerchPrint",
  PAID_MEDIA = "ExecutionBriefPaidMedia",
  SIMPLE = "ExecutionBriefSimple",
  WEB = "ExecutionBriefWebBanner",
}
